import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "../site/Motion";

const Tile = ({ to, className, children, testid }) => (
  <Link to={to} data-testid={testid} className={`group relative flex min-h-[340px] flex-col justify-between overflow-hidden rounded-[2rem] p-7 transition-transform duration-500 hover:-translate-y-1 sm:p-10 ${className}`}>
    {children}
  </Link>
);

const Arrow = ({ dark }) => (
  <span className={`flex h-12 w-12 items-center justify-center rounded-full transition-transform duration-500 group-hover:rotate-45 ${dark ? "bg-[#1E2621] text-[#F4F1EA]" : "bg-[#FDFBF7] text-[#1E2621]"}`}>
    <ArrowUpRight className="h-5 w-5" />
  </span>
);

export const ServicesBento = () => (
  <section className="bg-[#FDFBF7] py-20 sm:py-28 lg:py-32" data-testid="services-bento">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>What we offer</Eyebrow>
          <h2 className="font-serif-display mt-4 text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">Three ways we walk <span className="italic text-[#A9533A]">with you.</span></h2>
        </div>
        <Link to="/services" className="text-sm font-medium underline decoration-[#C86D51] underline-offset-8" data-testid="bento-all-services-link">All service details</Link>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 lg:mt-16 lg:grid-cols-12 lg:auto-rows-[440px] lg:gap-8">
        <Reveal className="lg:col-span-7">
          <Tile to="/services#peer-support" className="h-full text-[#F4F1EA]" testid="bento-peer-support">
            <img src="/images/group.jpg" alt="A peer support group in conversation" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B241E]/95 via-[#1B241E]/45 to-[#1B241E]/10" />
            <div className="relative flex items-start justify-between"><span className="font-mono-ui text-xs tracking-[0.2em] text-[#F4D3C6]">01</span><Arrow /></div>
            <div className="relative max-w-md">
              <h3 className="font-serif-display text-4xl sm:text-5xl">Peer Support</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#E6E9E3] sm:text-base">Delivered by Ohio Certified Peer Supporters, individual or group, in-person or by telehealth, tied to your personal recovery goals.</p>
            </div>
          </Tile>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.1}>
          <Tile to="/services#cdca-counseling" className="grain h-full bg-[#1B241E] text-[#F4F1EA]" testid="bento-cdca">
            <div className="relative flex items-start justify-between"><span className="font-mono-ui text-xs tracking-[0.2em] text-[#E9A88F]">02</span><Arrow /></div>
            <div className="relative">
              <h3 className="font-serif-display text-4xl sm:text-5xl">CDCA Counseling</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#C9CFC6] sm:text-base">Substance use services delivered by a Chemical Dependency Counselor Assistant under clinical supervision.</p>
            </div>
          </Tile>
        </Reveal>
        <Reveal className="lg:col-span-5">
          <Tile to="/services#life-coaching" className="h-full border border-[#E2DCD0] bg-[#F4F1EA] text-[#1E2621]" testid="bento-life-coaching">
            <div className="flex items-start justify-between"><span className="font-mono-ui text-xs tracking-[0.2em] text-[#A9533A]">03</span><Arrow dark /></div>
            <div>
              <span className="inline-block rounded-full border border-[#F3DBBA] bg-[#FFF8F0] px-3 py-1 text-xs font-semibold text-[#8A5416]" data-testid="bento-private-pay-badge">Private pay only</span>
              <h3 className="font-serif-display mt-4 text-4xl sm:text-5xl">Life Coaching</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#4A554D] sm:text-base">Goal-focused coaching for direction, accountability and your next chapter.</p>
            </div>
          </Tile>
        </Reveal>
        <Reveal className="lg:col-span-7" delay={0.1}>
          <div className="relative flex h-full min-h-[340px] flex-col justify-end overflow-hidden rounded-[2rem]" data-testid="bento-quote-tile">
            <img src="/images/convo.jpg" alt="Two people talking openly across a table" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1B241E]/90 via-[#1B241E]/55 to-transparent" />
            <p className="font-serif-display relative max-w-md p-7 text-3xl italic leading-tight text-[#FDFBF7] sm:p-10 sm:text-4xl">“Your goals set the direction. We help you keep moving.”</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
